import { Button, IconButton, Popover } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { useState } from 'react'
import { ArrowForwardIos, Close } from '@mui/icons-material'
import { DateRange, DateRangeProps } from 'react-date-range'
import { format } from 'date-fns'

export default function Filter(props: {
  filterByDate: (data: DateRangeProps['ranges'] | null) => void
  dateRange: DateRangeProps['ranges'] | undefined
}) {
  const { filterByDate } = props
  const [openFilterBox, setOpenFilterBox] = useState<HTMLButtonElement | null>(null)
  const [dateFilterOpen, setDateFilterOpen] = useState<HTMLButtonElement | null>(null)
  const [filters, setFilters] = useState<{
    selectionRange: DateRangeProps['ranges'] | null
  }>({
    selectionRange: props.dateRange || null,
  })
  const { selectionRange } = filters
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenFilterBox(event.currentTarget)
  }

  function resetFilter() {
    filterByDate(null)
    setOpenFilterBox(null)
  }

  function getLabel() {
    if (selectionRange && selectionRange[0].startDate && selectionRange[0].endDate) {
      return (
        <div className="bg-brand-50 text-brand-700 rounded-lg p-2">
          {selectionRange?.[0].startDate === selectionRange?.[0].endDate
            ? format(selectionRange?.[0].startDate, 'dd/MM/yyyy')
            : `${format(selectionRange?.[0].startDate, 'dd/MM/yyyy')}-${format(
                selectionRange?.[0].endDate,
                'dd/MM/yyyy'
              )}`}
        </div>
      )
    }
    return 'Filter'
  }

  function filterFunction(name: 'selectionRange' | 'treatment' | 'status', item: any) {
    const newFilters = {
      selectionRange: null,
      status: null,
      treatment: null,
    }
    newFilters[name] = item
    setFilters({
      ...newFilters,
    })
  }

  return (
    <div className="relative">
      <div className="flex items-center">
        <Button
          startIcon={<FilterListIcon />}
          variant="outlined"
          endIcon={<KeyboardArrowDownIcon />}
          className="border border-default text-neutral-500"
          onClick={handleClick}
        >
          {getLabel()}
        </Button>
        {selectionRange && (
          <IconButton
            className="w-fit h-fit ml-2"
            onClick={resetFilter}
            aria-label="Clear applied filter"
          >
            <Close />
          </IconButton>
        )}
      </div>
      <Popover
        open={Boolean(openFilterBox)}
        anchorEl={openFilterBox}
        onClose={() => setOpenFilterBox(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="rounded-xl bg-white w-full flex flex-col justify-center items-start rounded-10 bg-neutral-color-white shadow-default">
          <Button
            fullWidth
            onClick={(e) => {
              setDateFilterOpen(e.currentTarget)
            }}
            endIcon={<ArrowForwardIos className="text-xs" />}
            variant="text"
            className="hover:bg-white text-neutral-500 h-fit justify-start px-4"
          >
            Date
          </Button>
        </div>
      </Popover>

      <Popover
        open={Boolean(dateFilterOpen)}
        anchorEl={dateFilterOpen}
        onClose={() => {
          setDateFilterOpen(null)
        }}
      >
        <DateRange
          onChange={(item) => {
            resetFilter()
            filterFunction('selectionRange', [item.selection])
            filterByDate([item.selection])
          }}
          moveRangeOnFirstSelection={false}
          ranges={
            selectionRange || [
              {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection',
              },
            ]
          }
          showDateDisplay={false}
          rangeColors={['#FFFFFF']}
          color="#000000"
          className="date-range-picker rounded-xl"
        />
      </Popover>
    </div>
  )
}
